module.exports = __webpack_public_path__ + "static/media/about_profile_pic.6d0e06e8.png";